import { useState, useEffect } from 'react';
import { getProfile } from '../../services/studentActions/profile/actions';
import { useDispatch, useSelector  } from 'react-redux';
import { RootState } from '../../store/reducers';

const useProfile = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const profile = useSelector((state: RootState) => state.profile)
    const dispatch = useDispatch();
  
    useEffect(() => {
      const fetchProfile = async () => {
        try {
          dispatch(getProfile());
        } catch (err) {
          setError(err);
        } finally {
          setLoading(false);
        }
      }
      if ( profile && !profile.id && !profile.fullName ) {
        fetchProfile();
      } else {
        setLoading(false);        
      }
    }, []);
    return {
      error,
      loading,
      profile
    }
  }
  
  export default useProfile;